'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Link} from 'react-router';
import Spinner from 'components/base/Spinner';
import utils from 'services/utils';

import 'styles/ListSection.scss';

const propTypes = {
    moreLink: PropTypes.string,
    maxItems: PropTypes.number,
    loading: PropTypes.bool,
    multiSelect: PropTypes.bool,
    error: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
};

class ListSection extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {      

        var sectionHeaderContent = this.props.heading ? (
            <div className="list-section-header">
                
                <span className="lsh-text">
                    {this.props.heading}
                </span>
                
                {this.props.subHeading ? (
                    <div className="lsh-sub-heading">
                        {this.props.subHeading}
                    </div>
                ) : null}

                {this.props.headingActions && !this.props.downloading ? (
                    <div className="actions-container">
                        {this.props.headingActions}
                    </div>
                ) : null}

                {this.props.downloading ? (
                    <div className="actions-container">
                        <Spinner
                            display={this.props.downloading}
                            id={this.props.id}
                        />
                    </div>
                ) : null}

            </div>
        ) : null;

        var listContent = [];
        var footerContent = null;

        if (this.props.maxItems && this.props.children && this.props.children.length > 0) {
            
            var maxItems = this.props.maxItems;
            var totalItems = this.props.totalItems ? this.props.totalItems : this.props.children.length;
            var limit = totalItems < maxItems ? totalItems : maxItems;

            for (var i = 0; i < limit; i++) {
                listContent.push(this.props.children[i]);
            }

            if (this.props.moreLink && totalItems > maxItems) {
                footerContent = (
                    <div key={maxItems} className="end-list-options-container">
                        <Link
                            className="link"
                            to={this.props.moreLink}
                            query={this.props.query}
                        >
                            View more
                        </Link>
                    </div>
                );
            }

        } else {    
            listContent = this.props.children;
        }

        if (this.props.onLoadMoreCallback && !this.props.loading) {
            footerContent = (
                <div key={9999999} className="end-list-options-container">
                    <a
                        className="link"
                        href="javascript:void(0)"
                        onClick={this.props.onLoadMoreCallback}
                        query={this.props.query}
                    >
                        View more
                    </a>
                </div>
            );

        } else if (this.props.onLoadMoreCallback && this.props.loading) {
            footerContent = (
                <div key={9999999} className="end-list-options-container">
                    <Spinner
                        display={this.props.loading}
                        id={'spinner' + 9999999}
                        color={'#255bc7'}
                    />
                </div>
            );
        }

        var style;

        if (this.props.hide) {
            style = {display: "none"};
        }

        
        return (
            <div
                id={this.props.id ? "list-section-{0}".format(this.props.id) : null}
                className={footerContent ? "list-section end-list-options-container-spacer" : "list-section"}
                style={style}
            >
                {sectionHeaderContent}
            
                {listContent ? (
                    <div className="list-section-container">
                        {listContent}
                    </div>
                ) : null }
            
                {footerContent}
            </div>
        );
    }
}


ListSection.propTypes = propTypes;

export default ListSection; 